<ng-container *ngIf='!_isLoading'>
	<div class="container">
		<div [ngClass]="{'row': true, 'with_bottom': _response.total}" *ngIf='_response.total; else nodata'>
			<div class="col-md-12">
				<h2 class="next-trips">{{'Lista risultati' | translate}}</h2>

				<div class="row">
					<ng-container *ngFor='let product of _response.data'>
						<div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-12">
							<div class="tour_container">
								<ng-container [ngSwitch]='product.type'>
									<!-- TOUR -->
									<ng-container *ngSwitchCase='"package"'>
										<ng-container
											[ngTemplateOutlet]='headerProduct'
											[ngTemplateOutletContext]='{product: product, datasetCode: "trip_packages"}'
										></ng-container>

										<div class="body-experience">
											<h4 class="title">
												<a [routerLink]="['/d', appService.domainId, 'detail', 'trip_packages', product.id]">{{product.language_contents.description}}</a>
											</h4>
											<span class="experience-excerpt" *ngIf='product.language_contents.properties.tour_brief.value'>
												{{product.language_contents.properties.tour_brief.value}}
											</span>
											<div class="price-per-person" *ngIf='product.properties.price.value > 0'>
												{{'Da' | translate}} <span class="single-price">{{product.properties.price.value | currency:'EUR'}}</span> {{'a persona' | translate}}
											</div>
										</div>
									</ng-container>

									<!-- PRODOTTO -->
									<ng-container *ngSwitchCase='"product"'>
										<ng-container
											[ngTemplateOutlet]='headerProduct'
											[ngTemplateOutletContext]='{product: product, datasetCode: "products"}'
										></ng-container>

										<div class="body-experience">
											<h4 class="title">
												<a [routerLink]="['/d', appService.domainId, 'detail', 'products', product.id]">{{product.language_contents.description}}</a>
											</h4>
											
											<ng-container *ngIf='product.language_contents.full_description'>
												<div [innerHTML]='product.language_contents.full_description | slice' class="experience-excerpt"></div>
											</ng-container>
											
											<div class="price-per-person" *ngIf='product.properties.price.value > 0'>
												{{'Da' | translate}} <span class="single-price">{{product.properties.price.value | currency:'EUR'}}</span> {{'a persona' | translate}}
											</div>
										</div>
									</ng-container>

									<div *ngSwitchDefault>Nessun tipo di prodotto</div>
								</ng-container>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
		</div>

		<hr class="withmargin hidden-xs" *ngIf='_showPagination'>

		<!-- pagination -->
		<pager *ngIf='_showPagination'
			[current_page]='_response.current_page' 
			[last_page]='_response.last_page'
			(changePage)='changePage.emit($event)'
		></pager>
	</div>
</ng-container>

<ng-template #nodata>
	<h3>{{'Nessuna risultato disponibile' | translate}}</h3>
</ng-template>

<ng-template #headerProduct let-product='product' let-datasetCode='datasetCode'>
	<div class="header-experience">
		<a [routerLink]="['/d', appService.domainId, 'detail', datasetCode, product.id]">
			<img *ngIf='product.language_contents.master_image_id' [src]='appService.getBaseServerAddress() + "/document_files/resize/1024x768/" + product.language_contents.master_image_id' />
			<img *ngIf='!product.language_contents.master_image_id' src='assets/img/1024x768.png' />
		</a>
	</div>
</ng-template>